import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { mdiMenu, mdiBellBadgeOutline, mdiChevronLeft } from "@mdi/js";
import { useHistory } from "react-router-dom";
import "../../assets/styles/components/header.scss";
import VirtualList from 'rc-virtual-list';
import { Badge, Avatar, Dropdown, Space, Menu, Card, Skeleton, Button, List, message } from "antd";
import { UserOutlined } from '@ant-design/icons';
import axios from "axios";
interface Props {
  noHeader?: boolean;
  firstPage?: boolean;
  btnBack?: boolean;
  onClick?: () => void;
  title?: string;
  children?: object;
}


interface UserItem {
  email: string;
  gender: string;
  name: {
    first: string;
    last: string;
    title: string;
  };
  nat: string;
  picture: {
    large: string;
    medium: string;
    thumbnail: string;
  };
}
const ContainerHeight = 400;
const HeaderBar: React.FC<Props> = ({
  noHeader = false,
  btnBack = false,
  title = "",
  children,
  onClick
}) => {
  let history = useHistory();
  const [data, setData] = useState<UserItem[]>([]);
  const [count, setCount] = useState<number>(-1);
  const [list, setList] = useState<number>(0);
  const appendData = () => {
    if (count === -1 || count > list)
      axios.get(`/notification`).then((res) => {
        setData(data.concat(res.data?.data));
        setList(list + res.data?.data.length);
        // message.success(`${body.results.length} more items loaded!`);
      });
  };

  useEffect(() => {
    appendData();
  }, []);

  const onScroll = (e: React.UIEvent<HTMLElement, UIEvent>) => {
    if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop === ContainerHeight) {
      // appendData();
    }
  };
  const isRead = (id: string, index: number) => {
    axios.patch(`/notification/updateRead/${id}`).then((res) => {
      let newData: any = data;
      newData[index].isRead = true;
      setData(newData)
    });
  }
  const menu = (
    <Menu
      items={[
        {
          label: <p>Notification</p>,
          key: '0',
        },
        {
          label: <List
          style={{
            maxHeight: '450px',
            overflow: 'auto'
          }}
            dataSource={data}
            renderItem={(item: any, index: number) => (
              <List.Item key={item.createdAt} onClick={() => isRead(item?._id, index)}>
                <List.Item.Meta
                  avatar={
                    <>
                      {
                        (!item?.isRead) ?
                          <Badge dot>
                            <Avatar src="/image.png" icon={<UserOutlined />} />
                          </Badge>
                          :
                          <Avatar src="/image.png" />
                      }



                    </>
                  }
                  title={<a href="/">{item?.title}</a>}
                  description={<>
                    <Button type="primary" size="small" onClick={() => window.location = item.data.url} danger>
                      Answered
                    </Button>
                    <p>{item.createdAt}</p>
                  </>}
                />
              </List.Item>
            )}
          >
          </List>,
          key: '1',
        }
        // {
        //   label: <VirtualList
        //     data={data}
        //     height={ContainerHeight}
        //     itemHeight={47}
        //     itemKey="title"
        //     // onScroll={onScroll}
        //   >
        //     {(item: any, index: number) => (
        //       <List.Item key={item.createdAt} onClick={() => isRead(item?._id, index)}>
        //         <List.Item.Meta
        //           avatar={
        //             <>
        //               {
        //                 (!item?.isRead) ?
        //                   <Badge dot>
        //                     <Avatar src="/image.png" icon={<UserOutlined />} />
        //                   </Badge>
        //                   :
        //                   <Avatar src="/image.png" />
        //               }



        //             </>
        //           }
        //           title={<a href="/">{item?.title}</a>}
        //           description={<>
        //             <Button type="primary" size="small" onClick={() => window.location = item.data.url} danger>
        //               Answered
        //             </Button>
        //             <p>{item.createdAt}</p>
        //           </>}
        //         />
        //       </List.Item>
        //     )}
        //   </VirtualList>,
        //   key: '1',
        // }
      ]}
    />
  );

  const onDropdown = (e: any) => {
    setData([]);
    // axios.put(`/doctor/patient`).then((res) => {
    //   setData([]);
    //   setData(data.concat(res.data?.data));
    //   setList(list + res.data?.data.length);
    // });
    e.preventDefault()
  }
  return (
    <div className="header-bar">
      <div style={{ display: "flex", alignItems: "end", marginLeft: "20px" }}>
        {btnBack ? (
          <div style={{ cursor: "pointer" }} onClick={history.goBack}>
            <Icon
              icon="akar-icons:chevron-left"
              width="1.3rem"
              height="1.3rem"
              style={{ marginRight: "20px", marginBottom: " 4px" }}
            />
          </div>
        ) : (
          <div>
            {
              onClick ?
                <div style={{ cursor: "pointer" }} onClick={onClick}>
                  <Icon
                    icon="akar-icons:chevron-left"
                    width="1.3rem"
                    height="1.3rem"
                    style={{ marginRight: "20px", marginBottom: " 4px" }}
                  />
                </div>
                :
                ""
            }
          </div>
        )}

        {title}
      </div>
      <div className="icon">
        <div className="children">{children}</div>
        {/* <Icon
          className="icon-custom-bell"
          icon="clarity:bell-solid-badged"
          width="1.6rem"
          height="1.6rem"
          style={{ display: noHeader ? "none" : "block", marginRight: "20px", marginTop: "8px" }}
        /> */}
        <Dropdown overlay={menu} trigger={['click']}>
          <a onClick={e => e.preventDefault()}>
            <Space>
              <Badge count={data?.filter((item: any) => !item.isRead).length}>
                <Icon
                  className="icon-custom-bell"
                  icon="clarity:bell-line"
                  width="1.6rem"
                  height="1.6rem"
                />
              </Badge>
            </Space>
          </a>
        </Dropdown>

      </div>
    </div >
  );
};
export default HeaderBar;
